<template>
    <el-dialog class="recommend-resume-dialog"  title="修改职位" :visible.sync="showDialog">
        <component :is="'el-form'" :model="ruleForm" :rules="rules" ref="ruleForm" :key="preventKey" class="form-beauty"
                   label-width="100px">
            <el-form-item label="选择职位" prop="positionId">
                <transfer-select
                    :positionList="positionList"
                    delivery
                    v-model="ruleForm.positionId"
                    placeholder="请选择"
                />
            </el-form-item>
        </component>
        <div slot="footer">
            <el-button @click="showDialog = false">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
        </div>
    </el-dialog>
</template>

<script type="text/javascript">
    import fetchPositionListMixin from './fetchPositionListMixin'
    import formCommonMixin from 'mixins/formCommonMixin'
    import jobTransfer from './jobTransfer'

    export default {
        mixins: [fetchPositionListMixin, formCommonMixin],
        extends: jobTransfer,
        data () {
            return {
                showDialog: false,
                preventKey: 1,
                ruleForm: {
                    positionId: '',
                    rpIds: ''
                },
                rules: {
                    positionId: {required: true, message: '请选择', trigger: 'change'}
                }
            }
        },
        methods: {
            async show (data, list) {
                this.preventKey = +new Date()
                this.ruleForm.rpIds = data || ''
                this.ruleForm.positionId = ''
                await this.fetchPositionList()
                this.initPos(list)
                this.showDialog = true
            },
            initPos(list) {
                // 检查所选数据是否是同一职位，同一职位作初始值赋值
                const posIds = [...new Set(list.map(l => l.positionForm && l.positionForm.id))]
                const id = posIds.length === 1 && posIds[0] ? posIds[0].toString() : ''
                if (id) {
                    const ids = this.positionList.map(l => l.value)
                    this.ruleForm.positionId = ids.includes(id) ? id : ''
                }
            },
            saveForm (boolean) {
                this.$axios.post('/resume/changeDelivery.api', this.ruleForm, {'X-showMessage': true}).then(res => {
                    this.showDialog = false
                    this.$emit('reload')
                }).catch(console.error)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// changePositionDialog.vue?1e74097e